import { defineStore } from 'pinia'
import { paymentService } from '@/services/paymentService'
import { globalService } from '@/services/globalService'
import errorService from '@/services/errorService'

export const usePaymentStore = defineStore('payment', {
  state: () => ({
    payments: {
      data: {},
    },
    payment: {
      user: {},
      bank: {},
    },
    filter: {},
  }),

  actions: {
    async getPayments() {
      try {
        const response = await paymentService.fetchPayments(this.filter);
        this.payments = response.data;
        return { success: true };

      } catch (error) {
        return errorService.handle(error);
      }
    },

    async getPayment(id) {
      try {
        let payment = globalService.getObjectById(this.payments.data, id);

        if(payment){
          this.payment = payment;
        }else {
          const response = await paymentService.fetchPayment(id);
          this.payment = response.data.data;
        }

        return { success: true };
      }
      catch (error) {
        return errorService.handle(error);
      }
    },

    async addPayment() {
      try {
        await paymentService.requestPayment();

        return { success: true };
      }
      catch (error) {
        return errorService.handle(error);
      }
    },
  }
});